import _ from 'underscore';

function enumToProperties(name, enums) {
  const properties = {};

  _.each(enums, (val) => {
    properties[`${name}_${val}`] = {
      type: 'boolean',
    };
  });

  return properties;
}

function flattenSchemaProperties(...schemas) {
  const properties = {};

  _.each(schemas, (schema) => {
    _.each(schema.properties, (property, key) => {
      properties[`${schema.name}_${key}`] = property;
    });
  });

  return properties;
}

export class FlattenedSchemaGenerator {
  constructor({ deps }) {
    this.s$ImportUserPreferences = deps.schema.ImportUserPreferences;

    const importNewOptions = this.s$ImportUserPreferences.properties.ImportNewOptions.enum;
    const importUpdateOptions =
      deps.schema.ImportUpdateEntityPreference.properties.ImportUpdateOptions.enum;

    const adjustBids = _.clone(deps.schema.ImportAdjustmentForNumericProperty);
    adjustBids.name = 'AdjustmentForBids';
    const adjustBudgets = _.clone(deps.schema.ImportAdjustmentForNumericProperty);
    adjustBudgets.name = 'AdjustmentForCampaignBudgets';

    const properties = _.extend(
      {}, flattenSchemaProperties(
        deps.schema.LandingPageAppendPreference,
        deps.schema.LandingPageReplacePreference,
        deps.schema.AppendTrackingTemplatePreference,
        deps.schema.SearchAndReplacePreferencesForTrackingTemplate,
        deps.schema.ImportPrefixAndSuffixForStringProperty,
        deps.schema.ImportSearchAndReplaceForStringProperty,
        deps.schema.SearchAndReplaceForCustomParameters,
        deps.schema.SearchAndReplaceForFinalURLSuffix,
        adjustBids,
        adjustBudgets
      ),
      enumToProperties('ImportNewOption', importNewOptions),
      enumToProperties('ImportUpdateEntityPreference', importUpdateOptions),
      {
        StoreIdForImportedProductAdExtensionsFlag: {
          type: 'boolean',
        },
        ImportAccountUrlOptions: {
          type: 'boolean',
        },
        ImportNewLabelsAndAssociations: {
          type: 'boolean',
        },
        UpdateLabelsAndAssociations: {
          type: 'boolean',
        },
        ImportNewCustomFiltersForShoppingCampaigns: {
          type: 'boolean',
        },
        UpdateCustomFiltersForShoppingCampaigns: {
          type: 'boolean',
        },
        ImportNewOption_ImportNewBrandSuitability: {
          type: 'boolean',
          nullable: true,
        },
        ImportUpdateEntityPreference_UpdateBrandSuitability: {
          type: 'boolean',
          nullable: true,
        },
        TrackingTemplateValue: {
          type: 'string',
        },
        CustomParameterValue: {
          type: 'string',
        },
        FinalURLSuffixValue: {
          type: 'string',
        },
        FinalUrlSuffixValue: {
          type: 'string',
        },
        ImportUpdateEntityPreference_UpdateAdGroupAndKeywordBidStrategies: {
          type: 'boolean',
        },
        ImportUET: {
          type: 'boolean',
        },
        PauseAdGroupIfNoLocationSupported: {
          type: 'boolean',
        },
        RenameCampaignNameWithSuffix: {
          type: 'boolean',
        },
        NoAudienceTargetForFBImportOption: {
          type: 'boolean',
        },
        EnableAutoCurrencyConversion: {
          type: 'boolean',
        },
        PauseAIMAdGroupIfAllAudienceCriterionNotImported: {
          type: 'boolean',
        },
        ImportNewOption_ImportNewImageAdExtensions: {
          type: 'boolean',
          nullable: true,
        },
        ImportUpdateEntityPreference_UpdateImageAdExtensions: {
          type: 'boolean',
          nullable: true,
        },
        ImportNewOption_ImportNewLogoAdExtensions: {
          type: 'boolean',
          nullable: true,
        },
        ImportUpdateEntityPreference_UpdateLogoAdExtensions: {
          type: 'boolean',
          nullable: true,
        },
        ImportUpdateEntityPreference_UpdateAdUrls: {
          type: 'boolean',
          nullable: true,
        },
        ImportUpdateEntityPreference_UpdateSitelinkUrls: {
          type: 'boolean',
          nullable: true,
        },
        ImportNewOption_ImportNewAccountNegativeKeywords: {
          type: 'boolean',
          nullable: true,
        },
        ImportUpdateEntityPreference_UpdateAdCustomizerAttributes: {
          type: 'boolean',
          nullable: true,
        },
        ImportNewOption_ImportNewConversionGoals: {
          type: 'boolean',
          nullable: true,
        },
        ImportUpdateEntityPreference_UpdateConversionGoals: {
          type: 'boolean',
          nullable: true,
        },
      }
    );

    this.flattenedSchema = this.s$ImportUserPreferences;

    _.extend(this.flattenedSchema.properties, properties);

    this.flattenedSchema.required = [
      'ImportAppendDestUrlPreference_AppendStringForDestinationUrl',
      'ImportSearchAndReplaceDestUrlPreference_SearchStringForDestinationUrl',
      'AppendPreferencesForTrackingTemplate_AppendStringForTrackingTemplate',
      'SearchAndReplacePreferencesForTrackingTemplate_SearchStringForTrackingTemplate',
      'ImportPrefixAndSuffixForStringProperty_SuffixString',
      'ImportSearchAndReplaceForStringProperty_SearchString',
      'SearchAndReplaceForCustomParameters_SearchString',
      'SearchAndReplaceForFinalURLSuffix_SearchString',
    ];
  }

  getFlattenedSchemaWithProperties(...propertyNames) {
    const schema = _.clone(this.flattenedSchema);

    schema.properties = _.pick(schema.properties, (value, key) => {
      const flag = !!_.find(propertyNames, propertyName => key.indexOf(propertyName) !== -1);

      return flag && key.indexOf('_None') === -1;
    });

    return schema;
  }

  getCompleteFlattenedSchema() {
    return _.clone(this.flattenedSchema);
  }
}
